import { DocumentNode, gql } from '@apollo/client';

// Statisches Dokument mit GraphQL-Variablen (keine String-Interpolation mehr).
export const getLanguagesByCountryQuery: DocumentNode = gql`
  query GetLanguagesByCountry($countryId: String!) {
    languagesByCountry(countryId: $countryId) {
      id,
      name,
      languageCode,
    }
  }
`;
